module.exports = {"ACADEMIC":"Academic","COMMERCIAL":"Commercial","NA":"N/A","NON_PROFIT":"Non-Profit","UNKNOWN":"Unknown"}